import { arabicMessages } from './common';
export default { arabicMessages };

//ar_XA
